module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat2@2x-f4be58b36de08b56a2b6e9d5c576cfed.jpg";